// admin-panel/src/utils/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, get, push, remove, update, onValue, off } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDLsmnqt6wth0b3hZYrnllXnJIcjUaK8Uc",
  authDomain: "portfolio-e79b8-5854c.firebaseapp.com",
  projectId: "portfolio-e79b8-5854c",
  storageBucket: "portfolio-e79b8-5854c.firebasestorage.app",
  messagingSenderId: "694813500771",
  appId: "1:694813500771:web:199c8f7e7795e560205f56",
  measurementId: "G-SBRW34PBBE",
  databaseURL: "https://portfolio-e79b8-5854c-default-rtdb.firebaseio.com",
};
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);

// Firebase rejects writes containing `undefined` anywhere in the object.
// Ant Design forms can include untouched/optional fields as `undefined`,
// so we strip them before every write.
function stripUndefined(obj) {
  const cleaned = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== undefined) {
      cleaned[key] = obj[key];
    }
  });
  return cleaned;
}

// ─── POSTS CRUD ──────────────────────────────────────────────────────────────

export const getAllPosts = async () => {
  const snapshot = await get(ref(db, "posts"));
  if (!snapshot.exists()) return [];
  const data = snapshot.val();
  return Object.values(data).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
};

export const getPostById = async (id) => {
  const snapshot = await get(ref(db, `posts/${id}`));
  return snapshot.exists() ? snapshot.val() : null;
};

export const createPost = async (postData) => {
  // Get current posts to find next ID
  const snapshot = await get(ref(db, "posts"));
  let nextId = 1;
  if (snapshot.exists()) {
    const ids = Object.keys(snapshot.val()).map(Number);
    nextId = Math.max(...ids) + 1;
  }

  const newPost = stripUndefined({
    ...postData,
    id: nextId,
    createdAt: Date.now(),
    updatedAt: Date.now(),
  });

  await set(ref(db, `posts/${nextId}`), newPost);
  return newPost;
};

export const updatePost = async (id, postData) => {
  const updated = stripUndefined({
    ...postData,
    updatedAt: Date.now(),
  });
  await update(ref(db, `posts/${id}`), updated);
  return updated;
};

export const deletePost = async (id) => {
  await remove(ref(db, `posts/${id}`));
};

// ─── AUTHORS CRUD ─────────────────────────────────────────────────────────────

export const getAllAuthors = async () => {
  const snapshot = await get(ref(db, "authors"));
  if (!snapshot.exists()) return [];
  return Object.values(snapshot.val());
};

export const createAuthor = async (authorData) => {
  const snapshot = await get(ref(db, "authors"));
  let nextId = 1;
  if (snapshot.exists()) {
    const ids = Object.keys(snapshot.val()).map(Number);
    nextId = Math.max(...ids) + 1;
  }
  const newAuthor = stripUndefined({ ...authorData, id: nextId });
  await set(ref(db, `authors/${nextId}`), newAuthor);
  return newAuthor;
};

export const updateAuthor = async (id, data) => {
  await update(ref(db, `authors/${id}`), stripUndefined(data));
};

export const deleteAuthor = async (id) => {
  await remove(ref(db, `authors/${id}`));
};

// ─── SITE CONFIG ─────────────────────────────────────────────────────────────

export const getSiteConfig = async () => {
  const snapshot = await get(ref(db, "siteConfig"));
  return snapshot.exists() ? snapshot.val() : {};
};

export const updateSiteConfig = async (data) => {
  await update(ref(db, "siteConfig"), stripUndefined(data));
};

// ─── REAL-TIME LISTENER ───────────────────────────────────────────────────────

export const listenToPosts = (callback) => {
  const postsRef = ref(db, "posts");
  onValue(postsRef, (snapshot) => {
    if (snapshot.exists()) {
      const data = Object.values(snapshot.val()).sort(
        (a, b) => (b.createdAt || 0) - (a.createdAt || 0)
      );
      callback(data);
    } else {
      callback([]);
    }
  });
  return () => off(postsRef);
};

export default app;
